// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content_wrapper__3E4Dh","indicators":"Content_indicators__3kk5u"};